export const RESOURCE = 'adminmembership';
export const ACTIONS = { GetByAccountNumber: '/accountnumber', 
                         GetByMembershipNumber: '/membershipnumber', 
                         GetWithDetailByMembershipNumber: '/detail/membershipnumber',
                         GetPaymentDetailByMembershipNumber: '/paymentdetail',
                         AdjustCreditBalance: '/balance'  }